export default {
  // 模块名称
  accountGroup: {
    // 按钮类
    button: {
      add: '新增',
      batchDel: '批量删除',
      reset: '重置',
      query: '查询',
      save: '保存',
      cancel: '取消',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      setPermission: '权限设置',
      relation: '关联账户',
      back: '返回',
      export: '导出'
    },
    // 文字标签类
    label: {
      accountGroup: '角色名称',
      remark: '备注',
      creator: '创建人',
      createTime: '创建时间',
      lastModifyTime: '最后修改时间',
      operations: '操作',
      functionPermission: '功能权限',
      areaDevicePermission: '区域设备权限'
    },
    // 提示类
    placeholder: {
      accountGroup: '请输入角色名称',
      remark: '请输入备注'
    },
    // 消息类
    message: {
      accountGroup: '请输入角色名称',
      remark: '请输入备注',
      less30: '角色名称的长度在 4 到 30 个字符',
      formatAccount: '角色名称只包括字母、数字、汉字、下划线',
      less200: '备注信息不能超过200个字符',
      setSuccess: '设置账户成功',
      deltips: '您确定删除该角色吗?',
      batchDeltips: '您确定删除这些角色吗?',
      batchDel: '角色批量删除成功',
      selecttips: '请选择要删除的角色',
      delSuccess: '删除成功',
      addSuccess: '角色创建成功',
      editSuccess: '角色修改成功',
      setPermissionSuccess: '设置权限成功'
    },
    // 标题类
    title: {
      warn: '确认',
      resetPW: '重置密码',
      addAccountGroup: '新增角色',
      editAccountGroup: '修改角色',
      relations: '角色关联用户',
      selectableAccount: '可关联用户列表',
      permission: '菜单功能权限',
      selectedAccount: '已关联用户列表'
    }
  }
}